import styled from 'styled-components';
import {Button} from 'antd';

const StyledExpenseDetails = styled.div`
  .ant-divider {
    margin: 16px 0;
  }

  .ant-form-item {
    margin-bottom: 0;
    width: 100%;

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-picker {
      &:not(:active):not(:focus):not(:hover) {
        border-color: transparent;
      }
    }

    .ant-input {
      min-width: 50px;
      max-width: 220px;
      text-align: right;
    }

    .ant-select-outlined {
      &:not(:active):not(:focus):not(:hover) {
        .ant-select-selector {
          border-color: transparent;
        }
      }
    }
  }

  .ant-card-head {
    a {
      display: flex;

      svg {
        height: 10px;
        transition: .2s;
        width: 10px;
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }

      &:hover {
        svg {
          opacity: 0.6;
        }
      }
    }
  }

  table {
    tbody {
      tr {
        td {
          display: flex;
          &:nth-child(1) {
            text-wrap: nowrap;
          }
          &:nth-child(2) {
            display: flex;
            justify-content: end;
            width: 100%;
          }
        }
      }
    }
  }

  .expense-details-tags-select {
    width: 100%;
    display: flex;
    justify-content: end;
  }
`;

const StyledExpenseDetailsButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
  svg {
    height: 16px;
    width: 16px;
    path {
      stroke: ${props => props.theme.colors.neutral_1};
    }
  }
`;

export {
  StyledExpenseDetails,
  StyledExpenseDetailsButton,
};
